<template>
  <div>
    <div v-if="previousComponentFacebook === 'login'">
      <a style= "cursor: pointer" @click.prevent="connect" class="fb_btn btn--icon"><i class="icon-facebook"></i><span>{{ getTranslations.visitor_facebook_login_login_with_fb }}</span></a>
    </div>
    <div v-if="previousComponentFacebook === 'register3'">
    <i class="icon-profile"></i>
    <a style= "cursor: pointer" @click.prevent="login" class="fb_btn btn--icon"><i class="icon-facebook"></i><span>{{ getTranslations.visitor_facebook_login_continue_with }}</span></a>
          <!--<i class="icon-profile"></i>-->
            <!--<a href="#" @click="connect" class="fb_btn btn&#45;&#45;icon"><i class="icon-facebook"></i><span>$#Continue with Facebook</span></a>-->
           <!--<span class="form-group__feedback">$#This FB account has been used by another user. Please continue with a different Facebook account.</span>-->
          <!--<div class="form-group form-group&#45;&#45;or">-->
            <!--<div><span style="background: #fff;">$#OR</span></div>-->
          <!--</div>-->
    </div>
    <div v-if="previousComponentFacebook === 'profile'">
      <a style= "cursor: pointer">
        <section class="profile__block " @click.prevent="connect"><!--ADD CLASS fb_on IF THE USER IS ALREADY LOGGEDIN WITH FACEBOOK -->
          <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.visitor_sign_up_3_this_fb }}</span><!-- SHOW THIS SPAN IN CASE OF FB ERROR -->
          <div class="profile__block__content--fb_section">
            <img src="static/images/facebook-icon.svg" />
            <h2>{{ getTranslations.visitor_facebook_login_connect_before_points }} {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}</h2>
          </div>
        </section>
      </a>
    </div>
    <div v-if="previousComponentFacebook === 'editProfile'">
      <a style= "cursor: pointer" @click.prevent="connect">
        <section :class="['profile__block']"><!--ADD CLASS fb_on IF THE USER IS ALREADY LOGGEDIN WITH FACEBOOK else REMOVE-->
          <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.visitor_sign_up_3_this_fb }}</span><!-- SHOW THIS SPAN IN CASE OF ERROR -->
          <div class="profile__block__content--fb_section">
            <img src="static/images/facebook-icon.svg" />
            <h2>{{ getTranslations.visitor_facebook_login_connect_before_points }} {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}</h2>
          </div>
        </section>
      </a>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';

export default {
  name: 'facebook-login',
  props: ['errorsInFb', 'enteredUsername', 'previousComponentFacebook'],
  mixins: [FacebookMixin],
  data() {
    return {
      params: {
        scope: 'public_profile,email',
        return_scopes: true,
        enable_profile_selector: true,
      },
      facebookHide: false,
      accessToken: '',
      errorInFbLogin: false,
      errorInFbRegister: false,
      fb_error: false,
    };
  },
  created() {
    this.$emit('errorsUpdated', null);
    this.errorInFbLogin = false;
    this.errorInFbRegister = false;
//    window.FB.getLoginStatus((response) => {
//      console.log('FB connect: response:', response);
//      if (response.authResponse) {
//        window.FB.api('/me', { fields: 'first_name' }, (response2) => {
//          console.log('FB connect: response2:', response2);
//        });
//      }
//    });
    console.log('-----------------------------', this.previousComponentFacebook);
  },
  methods: {
    showError() {
      this.fb_error = true;
    },
    ...mapMutations('profile', [
      'setFirstTimeEntry',
    ]),
    ...mapMutations('common', [
      'storeUserAvatar',
    ]),
    ...mapActions('common', [
      'sendFacebookImage',
      'updateDisplayAvatar',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorizationFB',
      'getUserLoginDetails',
    ]),
    connect() {
      this.$emit('errorsUpdated', null);
      this.errorInFbLogin = false;
      console.log('this.enteredUsername: ', this.enteredUsername);
      if (this.enteredUsername === undefined || this.enteredUsername === '') {
        this.$emit('usernameChecked', 'Blank Username');
        return;
      }
      this.loginFbApi(this.params, this.userDetails.facebookId, this.successCallBack, this.invalidFbError);
    },
    successCallBack() {
      if (this.previousComponentFacebook === 'login' || this.previousComponentFacebook === 'profile' || this.previousComponentFacebook === 'editProfile') {
        this.accessToken = localStorage.getItem('accessToken');
        const userData = {
          accessToken: this.accessToken,
          msisdn: this.userDetails.msisdn !== '' ? this.userDetails.msisdn : null,
        };
        this.callForAuthorizationFB(userData).then(() => {
          if (this.getUserAuthorized) {
            if (this.previousComponentFacebook === 'login') {
              this.getUserLoginDetails().then(() => {
                if (this.getUserAuthorized) {
                  this.updateUserLanguage();
                  this.$router.push('home');
                } else {
                  this.$emit('errorsUpdated', 'visitor_login_server_error');
                  this.errorInFbLogin = true;
                  this.logout(this.showError);
                }
              });
            } else {
              this.getUserLoginDetails().then(() => {
                this.updateUserLanguage();
                window.FB.api('/me?fields=id,name,picture.width(300).height(300)', (response3) => {
                  localStorage.setItem('FacebookImage', response3.picture.data.url);
                  this.sendFacebookImage().then(() => {
                    this.updateDisplayAvatar();
                    this.storeUserAvatar(response3.picture.data.url);
                  });
                });
              });
            }
          } else {
            this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
            this.errorInFbLogin = true;
            this.logout(this.showError);
          }
        });
      }
    },
    invalidFbError() {
      console.log('User cancelled login or did not fully authorize.');
      this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
      this.errorInFbLogin = true;
    },
    /* eslint-disable */
    login() {
      console.log('errorsInFb ', this.errorsInFb);
      if (this.errorsInFb) {
        return;
      }
      this.$emit('errorsUpdated', null);
      this.errorInFbRegister = false;
      console.log('this.enteredUsername: ', this.enteredUsername);
      if (this.enteredUsername === undefined || this.enteredUsername === '') {
        this.$emit('usernameChecked', 'Blank Username');
        return;
      }

      window.FB.login((response) => {
        console.log('response:', response);
        if (response.authResponse) {
          localStorage.setItem('facebookConnected', 'true');
          this.facebookHide = true;
          window.FB.api('/me?fields=id,name,picture.width(300).height(300)', (response3) => {
            if (this.previousComponentFacebook === 'register3') {
              this.$emit('waitForCoreResponse', true);
              this.accessToken = response.authResponse.accessToken;
              this.$axios.get('api/subscribeUser', {
                params: {
                  msisdn: this.registrationInfoMsisdn,
                  username: this.enteredUsername,
                  password: "",
                  lang: this.getLocale,
                  operator: this.multiOperatorInfo.operatorPicked || '',
                  clickid: this.clickid,
                  refUrl: this.refUrl,
                  facebookId: response.authResponse.userID,
                  facebookImage: response3.picture.data.url,
                  fbReferral: this.fbReferral,
                },
              }).then((responseUser) => {
                this.$emit('waitForCoreResponse', false);
                if (responseUser.data.responseEnum === 'OPERATION_SUCCESS') {
                  const userData = {
                    accessToken: this.accessToken,
                  };
                  this.callForAuthorizationFB(userData).then(() => {
                    if (this.getUserAuthorized) {
                      console.log('--------------User AUTHIORIZED----------');
                      this.getUserLoginDetails().then(() => {
                        this.setFirstTimeEntry(true);
                        this.updateUserLanguage();
                        this.$router.push('home');
                      });
                    } else {
                      this.logout(() => {
                        this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
                        this.errorInFbRegister = true;
                      });
                    }
                  });
                } else {
                  this.logout(() => {
                    this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
                    this.errorInFbRegister = true;
                  });
                }
              });
            }
          });
        } else {
          this.logout(() => {
            this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
            this.errorInFbRegister = true;
            console.log('User cancelled login or did not fully authorize.');
          });
        }
      }, this.params);
    },

  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'userDetails',
      'connectionPoints',
      'fbReferral',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/FacebookLogin.vue